import React, { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { quoterSumRestClick } from '@utils/datalayer';

interface DependantCounterI {
  count: number;
  setCount: (count: number) => void;
  max?: number;
}

const DependantCounter = ({ count, setCount, max = 6 }: DependantCounterI): ReactElement => {
  const { t } = useTranslation();

  const addCountHandler = () => {
    quoterSumRestClick('Sumar');
    setCount(count + 1);
  };
  const subCountHandler = () => {
    if (count === 1) {
      return;
    }
    setCount(count - 1);
    quoterSumRestClick('Restar');
  };

  const dependantCounterKey = (count: number) => {
    if (count < 0) {
      throw new Error('Count must be greater than 0');
    }

    if (count === 0) {
      return 'nobody';
    } else if (count === 1) {
      return 'just_me';
    } else {
      return 'family_and_me';
    }
  };

  return (
    <div className="flex flex-row border border-[#AFBACC] rounded min-h-14 bg-white overflow-hidden">
      <div className="flex flex-1 flex-col justify-center pl-4">
        <p className="text-color/neutral/80 text-[13px] leading-4 font-semibold opacity-80">
          {count !== 0 && <Trans t={t} i18nKey="dependant_counter.title" />}
        </p>
        <p className="text-neutral/darkgrey/90 text-[16px] leading-6 font-semibold opacity-90">
          <Trans
            t={t}
            i18nKey={'dependant_counter.' + dependantCounterKey(count)}
            values={{
              plural: count > 2 ? 'es' : '',
              countFamily: count - 1,
              total: count,
            }}
          />
        </p>
      </div>
      <div className="flex w-1/6">
        <button
          type="button"
          className="flex flex-1 justify-center items-center bg-white border-x border-[#AFBACC] text-[34px] text-color/neutral/80 disabled:text-[#AFBACC] "
          onClick={subCountHandler}
          disabled={count === 1}
        >
          <span className="pl-1">-</span>
        </button>
      </div>
      <div className="flex w-1/6">
        <button
          type="button"
          className="flex flex-1 justify-center items-center bg-white text-center text-[28px] text-color/neutral/80 disabled:text-[#AFBACC] "
          onClick={addCountHandler}
          disabled={count >= max}
        >
          +
        </button>
      </div>
    </div>
  );
};

export default DependantCounter;
